import { render, staticRenderFns } from "./scenery.vue?vue&type=template&id=86fe7954&scoped=true"
import script from "./scenery.vue?vue&type=script&lang=js"
export * from "./scenery.vue?vue&type=script&lang=js"
import style0 from "./scenery.vue?vue&type=style&index=0&id=86fe7954&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe7954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86fe7954')) {
      api.createRecord('86fe7954', component.options)
    } else {
      api.reload('86fe7954', component.options)
    }
    module.hot.accept("./scenery.vue?vue&type=template&id=86fe7954&scoped=true", function () {
      api.rerender('86fe7954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/scenery.vue"
export default component.exports